import { render, staticRenderFns } from "./guidelines.vue?vue&type=template&id=69ce5312&scoped=true"
import script from "./guidelines.vue?vue&type=script&lang=js"
export * from "./guidelines.vue?vue&type=script&lang=js"
import style0 from "./guidelines.vue?vue&type=style&index=0&id=69ce5312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7907ed7515d572276d45114f834f04a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ce5312",
  null
  
)

export default component.exports